import { motion, AnimatePresence } from 'framer-motion';
import React from 'react';

// A simple standard animation that grows height in and out
// Usage:
//   <GrowInOut show={someBoolean} duration={0.5}>
//     <SomeComponent />
//   </GrowInOut>
export function GrowInOut(
  {
    show,
    children,
    duration = 1
  }: {
    show: boolean;
    children: React.ReactNode;
    duration?: number
  }
) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: duration, ease: [0.16, 1, 0.3, 1] }}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
